import React from "react";
import { isBirthdayToday, birthdayAge } from "../../lib/dates";

/**
 * Aviso por socio (petición Kong Club, 13-ago): si el cuadro de notas tiene
 * "abrir al interactuar" activado para ese socio, la nota salta como popup en
 * el check-in, al seleccionarlo en el POS y al atenderlo. Informativo y de un
 * toque — no bloquea el flujo rápido (el auto-open antiguo secuestraba la
 * interacción; por eso esto es opt-in socio a socio y compartido entre staff).
 *
 * 15-ago: el mismo popup lleva el CUMPLEAÑOS (petición Kong Club). Va aquí y no
 * en una ventana aparte a propósito: un socio puede tener nota Y cumplir años el
 * mismo día, y dos modales apilados en la tablet de la puerta serían un estorbo.
 *
 * Acepta las dos formas de payload: profile.{notes,notes_popup} (API) o los
 * campos a nivel raíz (shapes mapeadas tipo DispensarioPage.toSocio).
 */
export function notaConAviso(socio) {
  const p = socio?.profile || {};
  const flag = p.notes_popup ?? socio?.notes_popup;
  const nota = String(p.notes ?? socio?.notes ?? "").trim();
  return flag && nota ? nota : null;
}

/** ¿Hoy cumple años? Sin fecha de nacimiento (lo normal: es opcional) → false. */
export function cumpleHoy(socio) {
  const p = socio?.profile || {};
  return isBirthdayToday(p.birth_date ?? socio?.birth_date);
}

/**
 * ¿Hay algo que enseñar al staff sobre este socio? Nota con aviso o cumpleaños.
 * Los sitios de CHECK-IN usan esta; los de interacción del POS siguen disparando
 * solo con la nota (felicitar una vez al entrar está bien, que salte un popup cada
 * vez que le tocas en el POS durante toda la tarde, no).
 */
export function tieneAvisoSocio(socio) {
  return Boolean(notaConAviso(socio) || cumpleHoy(socio));
}

export default function NotaSocioPopup({ socio, onClose }) {
  const nota = notaConAviso(socio);
  const cumple = cumpleHoy(socio);
  if (!nota && !cumple) return null;
  const p = socio?.profile || {};
  const edad = cumple ? birthdayAge(p.birth_date ?? socio?.birth_date) : null;
  const nombre =
    `${p.first_name || socio?.first_name || ""} ${p.last_name || socio?.last_name || ""}`.trim() ||
    socio?.name ||
    socio?.email ||
    "Socio";
  return (
    <div
      className="fixed inset-0 z-[100000] flex items-center justify-center bg-black/40 p-4"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-1 text-xs font-semibold uppercase tracking-wide text-amber-600">
          {cumple && !nota ? "Cumpleaños" : "Sobre el socio"}
        </div>
        <h3 className="text-lg font-semibold text-gray-900">{nombre}</h3>
        {cumple && (
          <p
            data-testid="aviso-cumple"
            className="mt-3 flex items-center gap-2 rounded-xl border border-pink-200 bg-pink-50 px-4 py-3 text-sm font-medium text-gray-800"
          >
            <span aria-hidden className="text-lg">🎂</span>
            <span>Hoy es su cumpleaños{edad ? ` — cumple ${edad}` : ""}. ¡Felicítale!</span>
          </p>
        )}
        {nota && (
          <p className="mt-3 whitespace-pre-wrap rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-gray-800">
            {nota}
          </p>
        )}
        <button
          type="button"
          onClick={onClose}
          className="mt-4 w-full rounded-xl bg-gray-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-gray-800"
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
